import { useScrollReveal } from '@/hooks/useScrollReveal';

const categories = [
  {
    name: 'Seafood',
    count: '3,200+ SKUs',
    icon: 'ri-anchor-line',
    accent: 'text-secondary-600',
    bgLight: 'bg-secondary-50',
    image: 'https://readdy.ai/api/search-image?query=Professional%20industrial%20display%20of%20frozen%20seafood%20assortment%20including%20shrimp%20prawns%20fish%20fillets%20and%20squid%20on%20white%20trays%2C%20clean%20corporate%20food%20product%20photography%2C%20cool%20blue%20tones%2C%20studio%20lighting%2C%20high%20detail%2C%20organized%20grid%20layout&width=600&height=400&seq=freshhlock-cat-seafood&orientation=landscape',
  },
  {
    name: 'Poultry & Meat',
    count: '2,100+ SKUs',
    icon: 'ri-restaurant-line',
    accent: 'text-accent-600',
    bgLight: 'bg-accent-50',
    image: 'https://readdy.ai/api/search-image?query=Professional%20frozen%20poultry%20and%20meat%20products%20display%20with%20vacuum%20packed%20chicken%20portions%20and%20meat%20cuts%20on%20white%20surface%2C%20clean%20studio%20product%20photography%2C%20cool%20neutral%20lighting%2C%20high%20detail%20commercial%20food%20product%20shot&width=600&height=400&seq=freshhlock-cat-meat&orientation=landscape',
  },
  {
    name: 'Vegetables',
    count: '1,800+ SKUs',
    icon: 'ri-leaf-line',
    accent: 'text-secondary-500',
    bgLight: 'bg-secondary-50',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20frozen%20vegetables%20assortment%20including%20green%20peas%20corn%20and%20mixed%20vegetables%20in%20bulk%20packaging%2C%20clean%20product%20photography%20on%20white%20background%2C%20bright%20natural%20colors%2C%20professional%20food%20product%20shot%2C%20high%20detail&width=600&height=400&seq=freshhlock-cat-veggies&orientation=landscape',
  },
  {
    name: 'Ready-to-Eat',
    count: '1,400+ SKUs',
    icon: 'ri-bowl-line',
    accent: 'text-accent-500',
    bgLight: 'bg-accent-50',
    image: 'https://readdy.ai/api/search-image?query=Professional%20frozen%20ready%20to%20eat%20meal%20assortment%20including%20packaged%20frozen%20meals%20and%20snacks%20on%20white%20surface%2C%20clean%20corporate%20food%20product%20photography%2C%20warm%20neutral%20tones%2C%20studio%20lighting%2C%20high%20detail%20commercial%20shot&width=600&height=400&seq=freshhlock-cat-rte&orientation=landscape',
  },
];

export default function CategoryShowcase() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-widest mb-4">
            Trade Categories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Everything You Trade, In One Place
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            Browse our full trade catalogue across four major frozen food categories — all with standardised specifications and verified suppliers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {categories.map((cat) => (
            <div
              key={cat.name}
              className="group relative bg-card-50 rounded-xl overflow-hidden border border-card-200 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer card-animate"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="w-full sm:w-48 h-44 sm:h-auto overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${cat.bgLight} ${cat.accent} mb-3 animate-icon-float icon-hover-pop`}>
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-xl font-bold text-primary-700 mb-1">{cat.name}</h3>
                  <p className="text-sm text-foreground-400 mb-4">{cat.count}</p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-secondary-600 group-hover:text-accent-600 transition-colors">
                    View Trade Catalogue
                    <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}